import React from "react";
import { FC, SetStateAction } from "react";
import { IRule } from "../../../../../store/logic/types";
import Action from "./Action";
import { ILogicOptions } from "../../../../../libs/logicSelect";

import styles from "./styles.module.scss";

interface IProps {
    rule: IRule;
    setRule: (value: SetStateAction<IRule>) => void;
    sortedActionFields: ILogicOptions;
}

const ActionList: FC<IProps> = ({ rule, setRule, sortedActionFields }) => {
    return (
        <div className={styles.actionsDiv}>
            {rule.actions.map((_, index) => {
                return (
                    <Action
                        index={index}
                        rule={rule}
                        key={index}
                        setRule={setRule}
                        sortedActionFields={sortedActionFields}
                    />
                );
            })}
        </div>
    );
};

export default React.memo(ActionList);
